<div style="background: white;">
	<div style="display: flex; align-items: flex-start; padding: 10px 5px;">
		<span *ngIf="data?.icon === 'check_circle_outline'" style="flex-shrink: 0; margin-right: 8px;">
			<mat-icon style="color:green;">{{data?.icon}}</mat-icon>
		</span>
		<span *ngIf="data?.icon === 'highlight_off'" style="flex-shrink: 0; margin-right: 8px;">
			<mat-icon style="color:red;">{{data?.icon}}</mat-icon>
		</span>
		<div style="flex: 1; text-align: center; word-wrap: break-word; white-space: normal; word-break: break-word; color: inherit;"
			[innerHTML]="data?.message">
		</div>
	</div>
	<div style="text-align: center!important; margin-top: .5rem; bottom:5px;">
	  <button mat-button class="command-button" *ngIf="data?.showCancel"
	          (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
	  <button mat-button class="command-button"
	          *ngIf="data?.showOk" (click)="onOkClick()" >
		  		Ok</button>
	  <button mat-button class="command-button" *ngIf="data?.showNo"
	          (click)="onNoClick()"cdkFocusInitial>
		  No</button>
	  <button mat-button class="command-button" *ngIf="data?.showYes"
	          (click)="onYesClick()" >
		       Yes</button>
	  <button mat-button class="command-button" *ngIf="data?.showConfirm"
	          (click)="onConfirmClick()" >
		      Confirm</button>
	  <button mat-button class="command-button" *ngIf="data?.showClose"
	          (click)="onCloseClick()" cdkFocusInitial>
		      Close</button>
	</div>
</div>
